import axiosInstance from "../api";
import { notification } from "antd";

// get Recommendations
export const getAllRecommendations = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/recommendation/all?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Recommendations",
      description:
        response?.data?.message || "Failed to fetch Recommendations list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching recommendation",
      description:
        error.response?.data?.message || "Failed to fetch recommendation list.",
      duration: 3,
    });
    throw new Error("Error fetching recommendation list");
  }
};

// get user recommendations
export const getUsersRecommendations = async (user_id) => {
  try {
    const response = await axiosInstance.get(
      `/recommendation/users?user_id=${user_id}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Recommendations",
      description:
        response?.data?.message || "Failed to fetch Recommendations list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching recommendation",
      description:
        error.response?.data?.message || "Failed to fetch recommendation list.",
      duration: 3,
    });
    throw new Error("Error fetching recommendation list");
  }
};

export const createRecommendation = async (recommendationData) => {
  try {
    const formData = new FormData();
    formData.append("name", recommendationData.name);
    formData.append("description", recommendationData.description);
    if (recommendationData.image) {
      formData.append("image", recommendationData.image);
    }

    const response = await axiosInstance.post("/recommendation/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Creation Error",
        description:
          response.data.message ||
          "An error occurred while creating the recommendation.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Creation Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error creating recommendation"
    );
  }
};

export const updateRecommendation = async (recommendationData) => {
  try {
    const formData = new FormData();
    if (recommendationData.name) {
      formData.append("name", recommendationData.name);
    }
    if (recommendationData.description) {
      formData.append("description", recommendationData.description);
    }
    if (recommendationData.image) {
      formData.append("image", recommendationData.image);
    }
    if (recommendationData.id) {
      formData.append("recommendation_id", recommendationData.id);
    }

    const response = await axiosInstance.put(
      `/recommendation/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description:
          response.data.message ||
          "An error occurred while creating the recommendation.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error creating recommendation"
    );
  }
};

export const activateDeactivateRecommendation = async (updateId, active) => {
  try {
    const payload = { recommendation_id : updateId, active: active}
    const response = await axiosInstance.put(`/recommendation/activate_deactivate`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};

